export default "__VITE_ASSET__DkwCSeze__"